import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CurrencyConverter from '../../CurrencyConverter';
import renderTooltip from '../../../components/siteadmin/SiteSettingsForm/toolTipHelper.js';
import messages from '../../../locale/messages';

import s from './Payment.css';

class PaymentDetails extends Component {
  static propTypes = {
    basePrice: PropTypes.number.isRequired,
    cleaningPrice: PropTypes.number,
    tax: PropTypes.number,
    currency: PropTypes.string.isRequired,
    dayDifference: PropTypes.number.isRequired,
    discount: PropTypes.number,
    discountType: PropTypes.string,
    priceForDays: PropTypes.number.isRequired,
    serviceFees: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    formatMessage: PropTypes.any,
    bookingSpecialPricing: PropTypes.array,
    isSpecialPriceAssigned: PropTypes.bool,
  };

  static defaultProps = {
    bookingSpecialPricing: [],
    isSpecialPriceAssigned: false,
  };


  render() {
    const { cleaningPrice, tax, currency, dayDifference, isAverage, petFeeValue } = this.props;
    const { priceForDays, serviceFees, discount, discountType, total, isSpecialPriceAssigned, taxValue, convertTotal, petFee } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <h3 className={cx(s.pricingTitle, 'rtlBookText')}><FormattedMessage {...messages.priceDetails} /></h3>
        <div className={cx(s.grid)}>
          <div className='tooltipFlex paymentDetailsFlexLeft'>
            {isSpecialPriceAssigned &&
              <>{renderTooltip(formatMessage(messages.averagePricePerNight), 'commonTooltipIcon')}</>
            }
            <div className={cx(s.specialPriceText, 'directionLtrTextRight')}>
              <CurrencyConverter
                amount={isAverage}
                from={currency}
              />
              {' x'} {dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
            </div>
          </div>

          <div className='paymentDetailsFlexRight'>
            <CurrencyConverter
              amount={priceForDays}
              from={currency}
            />
          </div>
        </div>

        {cleaningPrice > 0 && <div className={cx(s.grid)}>
          <div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.cleaningFee} /></div>
          <div className='paymentDetailsFlexRight'>
            <CurrencyConverter
              amount={cleaningPrice}
              from={currency}
            />
          </div>
        </div>
        }
        {serviceFees > 0 && <div className={cx(s.grid)}>
          <div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.serviceFee} /></div>
          <div className='paymentDetailsFlexRight'>
            <CurrencyConverter
              amount={serviceFees}
              from={currency}
            />
          </div>
        </div>
        }
        {petFee > 0 && <div className={cx(s.grid)}>
          <div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.petFee} /></div>
          <div className='paymentDetailsFlexRight'>
            <CurrencyConverter
              amount={petFeeValue}
              from={currency}
            />
          </div>
        </div>
        }
        {tax > 0 && <div className={cx(s.grid)}>
          <div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.tax} /> {`(${taxValue.toFixed(2)}%)`}</div>
          <div className='paymentDetailsFlexRight'>
            <CurrencyConverter
              amount={tax}
              from={currency}
            />
          </div>
        </div>
        }
        {discount > 0 && <div className={cx(s.grid, s.discountText)}>
          <div className='paymentDetailsFlexLeft' >{discountType}</div>
          <div className='paymentDetailsFlexRight'>
            -  <CurrencyConverter
              amount={discount}
              from={currency}
            />
          </div>
        </div>
        }

        <div className={cx(s.grid, s.totalValue)}>
          <div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.total} /></div>
          <div className='paymentDetailsFlexRight'> <CurrencyConverter
            amount={convertTotal > 0 ? convertTotal : total}
            from={currency}
          /></div>
        </div>
      </div>
    );
  }
}



const selector = formValueSelector('PaymentForm'); // <-- same as form name

const mapState = (state) => ({
  dayDifference: selector(state, 'dayDifference'),
  priceForDays: selector(state, 'priceForDays'),
  discount: selector(state, 'discount'),
  discountType: selector(state, 'discountType'),
  tax: selector(state, 'taxPrice'),
  serviceFees: selector(state, 'guestServiceFee'),
  total: selector(state, 'totalValue'),
  isSpecialPriceAssigned: selector(state, 'isSpecialPriceAssigned'),
  isAverage: selector(state, 'isSpecialPriceAverage'),
  convertTotal: selector(state, 'convertTotal'),
  toCurrency: state.currency.to || state.currency.base,
});

const mapDispatch = {
};


export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(PaymentDetails)));
